export default __webpack_public_path__ + "static/media/wordpress.1c0bf6df.svg";